<template>
    <header style=" background-color: #505458; height: 100%; width: 100%; display: flex; flex-wrap: nowrap; flex-direction: row; justify-content: flex-start; align-items: center;">
        <div style=" display: flex; align-items: center; width:200px; margin-left: 30px; cursor: pointer; ">
        <img
          src="http://rivermap-file.oss-cn-hangzhou.aliyuncs.com/lj/WeServerManage/logo-weserver.png"
          style="width: 40px; height: 40px; margin-right: 10px" />
        <div style="color:white;width:100px;">后台管理系统</div>
      </div>
        <el-menu style="width:100%;height:50px;margin-left:100px" mode="horizontal" background-color="#505458"
                  text-color="#fff"
                  :default-active="key"
                  active-text-color="#ffd04b"
                  @select="handleSelect">
            <el-menu-item :index="item.name" v-for="(item, index) in userMenus" :key="index " style="height:50px;width:100px;display:block;line-height:50px">
                <template slot="title">
                    <span slot="title">{{ item.name }}</span>
                </template>
            </el-menu-item>
        </el-menu>
        <div style=" height:50px;display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: flex-end; align-items: center;">
                <el-popover placement="bottom" width="150px">
                    <h3 style="text-align: center">用户：{{ username }}</h3>
                    <el-button @click="Logout" type="info" style="position: relative; left: 30px">退出登录</el-button>
                    <el-button slot="reference" circle icon="el-icon-user-solid" style="background-color:white"></el-button>
                </el-popover>
         </div>
    </header>

</template>

<script>
import { userLogout} from "@/http/api";
import store from '@/store'

export default {
    inject:['reload'],
    name: "Header",
    data() {
        return {
            username: store.state.user.account,
            userMenus : store.state.user.menus,
            key:store.state.key,
        }
    },

    methods: {
        Logout() {
            userLogout();
            this.$router.push({path: 'login'})
        },
        handleSelect(key) {
            this.$store.commit('addKey', key);
            //这里处理拿到第一个有权限的页面，拿不到才跳转欢迎页面
            let tempMenus = store.state.user.menus.filter(item => item.name === this.$store.state.key)
            let redirectPath = '/'
            let tempMenu = (tempMenus != null && tempMenus.length > 0)?tempMenus[0]:null
            while (tempMenu != null && tempMenu.children != null && tempMenu.children.length > 0){
                let first = tempMenu.children[0]
                if(first.path != null && first.path.length > 0){
                    redirectPath = first.path
                    break
                }else {
                    tempMenu = first
                }
            }
            this.$router.push({path: redirectPath});
            this.reload();
            console.log(this.$store.state.key+'111')
        }
    },

}
</script>

<style scoped>
</style>
